"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitAndExecute = void 0;
const waitAndExecute = (callback, delay) => {
  setTimeout(callback, delay);
};
exports.waitAndExecute = waitAndExecute;
